var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import axios from "axios";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import { router } from '@inertiajs/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import * as z from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
export default function BookingCancelButton(_a) {
    var team = _a.team, appointment = _a.appointment, calendar = _a.calendar;
    var route = useRoute(Ziggy);
    var _b = useState({}), slotsByDate = _b[0], setSlotsByDate = _b[1];
    var toast = useToast().toast;
    var _c = useState(appointment.start_date), date = _c[0], setDate = _c[1];
    var _d = useState(0), step = _d[0], setStep = _d[1];
    var _e = useState(appointment.start_date), slot = _e[0], setSlot = _e[1];
    var _f = useState(false), submitting = _f[0], setSubmitting = _f[1];
    var formSchema = z.object({
        send_email: z.boolean(),
        message: z.string().min(2).max(255),
    });
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            send_email: true,
            message: "",
        },
    });
    function submit() {
        setSubmitting(true);
        axios.post(route('appointments.cancel', { team: team, appointment: appointment }), {
            send_email: form.getValues().send_email,
            message: form.getValues().message,
        }).then(function (response) {
            // setStep(3);
            var toastOpts = {
                title: "Appointment cancelled",
            };
            toast(toastOpts);
            setIsOpen(false);
            setSubmitting(false);
            router.reload();
        }, function (error) {
            alert("An unexpected error has occurred");
            setSubmitting(false);
        });
    }
    function onOpenChange(open) {
        if (open) {
            setIsOpen(true);
        }
        else {
            setIsOpen(false);
        }
    }
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    useEffect(function () {
    }, [isOpen]);
    return (_jsxs(Dialog, __assign({ open: isOpen, onOpenChange: onOpenChange }, { children: [_jsx(DialogTrigger, __assign({ asChild: true }, { children: _jsx("button", __assign({ onClick: function () {
                    }, className: "text-red-600 hover:text-red-900" }, { children: "Cancel" })) })), _jsxs(DialogContent, __assign({ onPointerDownOutside: function (e) { return e.preventDefault(); }, className: "sm:max-w-md" }, { children: [_jsx(DialogHeader, { children: _jsx(DialogTitle, { children: "Cancel Booking" }) }), _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(function () { }), className: "space-y-6" }, { children: [_jsx(FormField, { control: form.control, name: "send_email", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "flex flex-row items-start space-x-4 space-y-0" }, { children: [_jsx(FormControl, { children: _jsx(Checkbox, { checked: field.value, onCheckedChange: field.onChange }) }), _jsx("div", __assign({ className: "space-y-1 leading-none" }, { children: _jsx(FormLabel, { children: "Send email to client" }) }))] })));
                                    } }), _jsx(FormField, { control: form.control, name: "message", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, { children: [_jsx(FormControl, { children: _jsx(Textarea, __assign({ placeholder: "Type your message here... (optional)" }, field, { disabled: !form.getValues("send_email") })) }), _jsx(FormMessage, {})] }));
                                    } })] })) })), _jsx(Button, __assign({ onClick: submit, type: "submit", variant: "destructive", disabled: submitting }, { children: "Cancel booking" }))] }))] })));
}
